import { useLocation } from "wouter";
import { Crosshair, BookOpen } from "lucide-react";

const tabs = [
  { path: "/", label: "Scorecard", icon: Crosshair },
  { path: "/ledger", label: "Ledger", icon: BookOpen },
] as const;

export function BottomNav() {
  const [location, navigate] = useLocation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 safe-area-bottom"
      data-testid="bottom-nav"
    >
      <div className="flex justify-around items-center h-14 max-w-md mx-auto">
        {tabs.map((tab) => {
          const isActive = tab.path === "/" ? location === "/" : location.startsWith(tab.path);
          const Icon = tab.icon;
          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                isActive
                  ? "text-emerald-800"
                  : "text-gray-500"
              }`}
              data-testid={`nav-${tab.label.toLowerCase()}`}
            >
              <Icon
                size={22}
                strokeWidth={isActive ? 2.5 : 1.5}
              />
              <span className={`text-xs mt-0.5 ${isActive ? "font-bold" : "font-medium"}`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
